"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16c-4.411 0-8-3.589-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.411-3.589 8-8 8ZM8 .941A7.066 7.066 0 0 0 .941 8 7.067 7.067 0 0 0 8 15.059 7.067 7.067 0 0 0 15.059 8 7.066 7.066 0 0 0 8 .941ZM5.243 7.356a1 1 0 1 0 0-2.001 1 1 0 0 0 0 2Zm6.514-1a1 1 0 1 1-2-.001 1 1 0 0 1 2 0Zm-7.59 4.889a.5.5 0 0 0 .5.5h6.667a.5.5 0 0 0 0-1H4.667a.5.5 0 0 0-.5.5Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c6.616 0 12 5.383 12 12s-5.384 12-12 12Zm0-22.925C5.976 1.075 1.075 5.976 1.075 12c0 6.025 4.901 10.926 10.925 10.926 6.024 0 10.925-4.901 10.925-10.926 0-6.024-4.901-10.925-10.925-10.925Zm-4.135 9.96a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9.77-1.5a1.5 1.5 0 1 1-2.999 0 1.5 1.5 0 0 1 3 0ZM7.281 17.4h9.438a.531.531 0 0 0 0-1.062H7.281a.531.531 0 0 0 0 1.062Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 32C7.178 32 0 24.823 0 16 0 7.178 7.178 0 16 0s16 7.178 16 16c0 8.823-7.178 16-16 16Zm0-30.567C7.968 1.433 1.433 7.968 1.433 16c0 8.033 6.535 14.568 14.567 14.568S30.567 24.033 30.567 16c0-8.032-6.535-14.567-14.567-14.567Zm-5.514 13.28a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm13.028-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM9.709 23.2h12.584a.708.708 0 0 0 0-1.416H9.709a.708.708 0 0 0 0 1.416Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24 48C10.766 48 0 37.233 0 24 0 10.766 10.766 0 24 0s24 10.766 24 24c0 13.233-10.766 24-24 24Zm0-46.196C11.761 1.804 1.805 11.761 1.805 24S11.762 46.196 24 46.196c12.239 0 22.196-9.957 22.196-22.196 0-12.24-9.957-22.195-22.196-22.195Zm-8.27 20.264a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm19.54-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM13.063 33.736c0 .517.42.937.938.937h20a.938.938 0 0 0 0-1.875H14a.938.938 0 0 0-.938.938Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32 64C14.355 64 0 49.644 0 32 0 14.355 14.355 0 32 0s32 14.355 32 32c0 17.644-14.355 32-32 32Zm0-61.594C15.682 2.406 2.406 15.681 2.406 32c0 16.318 13.276 29.594 29.594 29.594S61.594 48.318 61.594 32C61.594 15.681 48.318 2.406 32 2.406ZM20.973 29.424a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm26.055-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM17.417 44.981c0 .69.56 1.25 1.25 1.25h26.666a1.25 1.25 0 0 0 0-2.5H18.668c-.69 0-1.25.56-1.25 1.25Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconFeedbackNeutral = function IconFeedbackNeutral(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Feedback Neutral' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "FeedbackNeutral"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconFeedbackNeutral.sizes = [16, 24, 32, 48, 64];
IconFeedbackNeutral.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconFeedbackNeutral;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/FeedbackNeutral.js
// module id = 2378
// module chunks = 0